import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Enlaces de seguimiento',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Redes sociales',
  },
  form: {
    utm_source: {
      label: 'Fuente',
      placeholder: 'Seleccionar fuente',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Otras redes sociales',
        [CustomUtmSource.Other]: 'Otro',
      },
    },
    utm_source_details: {
      label: 'Fuente personalizada',
      placeholder: 'Ingresar fuente',
    },
    target_product: {
      label: 'Destino',
      placeholder: 'Seleccionar destino',
    },
    target_url: {
      label: 'URL de destino',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medio',
      placeholder: 'Ingresar medio',
    },
    utm_campaign: {
      label: 'Campaña',
      placeholder: 'Ingresar campaña',
    },
  },
  fields: {
    utm_source: 'Fuente',
    target_product: 'Destino',
    type: 'Tipo',
    utm_medium: 'Medio',
    utm_campaign: 'Campaña',
    utm_referrer_id: 'ID de referencia',
  },
  buttons: {
    create_auto_links: 'Crear enlaces automáticos',
    create_link: 'Crear enlace',
    create: 'Crear',
    update: 'Actualizar',
    copy_link: 'Copiar enlace',
    download_qr_code: 'Descargar código QR',
    edit: 'Editar',
  },
  modals: {
    auto_links_creation: {
      title: '¿Estás seguro?',
      description:
        'Asegúrate de haber completado la configuración de la tienda (subdominio de la tienda en línea / dominio del escaparate). Cambiarlos tras crear los enlaces no afectará automáticamente a los enlaces existentes.',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
    link_got_copied: '¡Enlace copiado!',
    failed_to_download_qr_code: 'Error al descargar el código QR',
  },
};
